import axios from 'axios';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { reduxForm } from 'redux-form';
import MobileVersionEditModal from './modal/MobileVersionEditModal';
import moment from 'moment';

var _ = require('lodash');

class MobileVersionTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      table_data: [],
      isShowModalEdit: false,
      mobileVersionSelected: null
    }
  }

  componentDidMount() {
    this.listReload();
  }

  listReload = () => {
    const self = this;

    axios({
      method: 'get',
      url: window.api_url + '/api/mobile/version',
      withCredentials: true,
    }).then(function (response) {
      self.setState({
        table_data: response.data.data
      })
    });
  }

  onShowModalEdit = (item) => {
    this.setState({
      isShowModalEdit: true,
      mobileVersionSelected: item
    })
  }

  onHideModal = () => {
    this.setState({
      isShowModalEdit: false,
      mobileVersionSelected: null
    })
    this.listReload();
  }

  render() {
    const {table_data, isShowModalEdit, mobileVersionSelected } = this.state;
    const self = this;
    const rows = _.map(table_data, function(i, index) {
      return (
        <tr key={index}>
          <td>
            <small>{i.type}</small>
          </td>
          <td>
            <small>{i.version}</small>
          </td>
          <td>
            <small>{i.build}</small>
          </td>
          <td>
            <small>{moment(i.updated_date).format("DD MM YYYY HH:mm:ss")}</small>
          </td>
          <td>
            <a onClick={() => self.onShowModalEdit(i)} className="dropdown-item">
              <i className="icon-pencil5"></i>
            </a>
          </td>
        </tr>
      )})
    return(
      <React.Fragment>
        <ToastContainer />
        <div className="page-header">
          <div className="page-header-content header-elements-md-inline">
            <div className="page-title d-flex">
              <h4>
                <i className="icon-paragraph-justify2 mr-2"></i>
                <span className="text-semibold"> App Version </span>
              </h4>
            </div>
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="table-responsive">
                <table className="table table-togglable table-hover">
                  <thead>
                    <tr>
                      <th data-toggle="true">
                        Phân Loại
                      </th>
                      <th style={{whiteSpace: 'nowrap'}} data-hide="phone">
                        Version
                      </th>
                      <th data-hide="phone">
                        Build
                      </th>
                      <th data-hide="phone">
                        Ngày Cập Nhật
                      </th>
                      <th className="text-center footable-visible footable-last-column" style={{width: "30px"}}>
                        <i className="icon-menu-open2"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {isShowModalEdit && <MobileVersionEditModal
            title="Ghi chú"
            mobileVersionObj = {mobileVersionSelected}
            show = {isShowModalEdit}
            onHide = {this.onHideModal}
          />}
        </div>
      </React.Fragment>
    )
  }
}


const mapState = state => ({
  role_path: state.userProfile.role_path,
  userProfile: state.userProfile.data
});

const mapDispatch = (dispatch) => ({
});


const MobileVersionTableWrapper = reduxForm({
  form: 'CustomerTable',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(MobileVersionTable);

export default connect(mapState, mapDispatch)(withRouter(MobileVersionTableWrapper));
